import { useContext } from 'react'
import { components, utils } from '@digital-commerce/shared-utils'
import { func, object } from 'prop-types'
import { intersperse } from 'ramda'

import { Typography, Notification } from '@telus-uds/components-web'

import localeContext from '../../../../contexts/Locale'
import { getOutOfStockItems } from '../../../../utils/rti'

const { getDisplayName } = utils.cart
const { ShouldRender } = components

const OutOfStockNotification = ({ cart, translate }) => {
  const { lang } = useContext(localeContext)
  const outOfStockItems = getOutOfStockItems(cart)
  const t = (path) => translate(`appNotification.outOfStockNotification.${path}`)

  if (outOfStockItems.length === 0) return null

  const formatItemNames = () => {
    const itemNameList = outOfStockItems
      .map(getDisplayName)
      .filter((itemName) => itemName !== undefined)
    const itemNamesExceptLast = itemNameList.slice(0, -1)
    const lastItemName = itemNameList.slice(-1)

    const formattedWithPunctuation = intersperse(', ', itemNamesExceptLast)

    if (itemNameList.length > 1) {
      const itemNames = formattedWithPunctuation.map((itemName) => {
        return (
          <Typography variant={{ size: 'medium', bold: true }} key={itemName}>
            {itemName}
          </Typography>
        )
      })

      return (
        <Typography variant={{ size: 'medium' }}>
          {itemNames}
          {t('conjunction')}
          <Typography variant={{ size: 'medium', bold: true }}>{lastItemName}</Typography>
        </Typography>
      )
    }

    return <Typography variant={{ size: 'medium', bold: true }}>{lastItemName}</Typography>
  }

  return (
    <Notification
      variant={{ validation: 'error' }}
      data-test-id="cart-top-level-out-of-stock-notification"
    >
      <Typography variant={{ size: 'medium' }}>
        <ShouldRender when={lang === 'en'}>
          {t('heading')}
          {formatItemNames()}
          {outOfStockItems.length === 1 ? t('messageSingle') : t('messageMultiple')}
        </ShouldRender>
        <ShouldRender when={lang === 'fr'}>
          {outOfStockItems.length === 1 ? t('headingSingle') : t('headingMultiple')}
          {formatItemNames()}
          {t('message')}
        </ShouldRender>
      </Typography>
    </Notification>
  )
}

OutOfStockNotification.propTypes = {
  cart: object.isRequired,
  translate: func.isRequired
}

export default OutOfStockNotification
